import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BotEvent } from '../models/botevent.model';
import { AppConfigService } from '../../shared/appconfig/appconfig.service';

@Injectable({
  providedIn: 'root'
})
export class BotEventService {
  private baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = AppConfigService.settings.get('chatstyleapiServer') + 'botevents';
  }

  /**
   * Get bot events for the current tenant with optional filtering and paging.
   * Tenant scope is implicit (per-tenant DB) — no botId in the URL.
   */
  getBotEvents(
    category?: string,
    severity?: string,
    fromDate?: Date | string,
    toDate?: Date | string,
    skip: number = 0,
    take: number = 50,
    channel?: string,
    search?: string
  ): Observable<{ items: BotEvent[], totalCount: number }> {
    let params = new HttpParams()
      .set('skip', skip.toString())
      .set('take', take.toString());

    if (category) {
      params = params.set('category', category);
    }
    if (severity) {
      params = params.set('severity', severity);
    }
    if (fromDate) {
      const dateStr = fromDate instanceof Date ? fromDate.toISOString() : fromDate;
      params = params.set('fromDate', dateStr);
    }
    if (toDate) {
      const dateStr = toDate instanceof Date ? toDate.toISOString() : toDate;
      params = params.set('toDate', dateStr);
    }
    if (channel) {
      params = params.set('channel', channel);
    }
    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<{ items: BotEvent[], totalCount: number }>(this.baseUrl, { params });
  }

  /**
   * Get available filter options (categories, severities, channels)
   */
  getEventFilters(): Observable<{ categories: string[], severities: string[], channels?: string[] }> {
    return this.http.get<{ categories: string[], severities: string[], channels?: string[] }>(`${this.baseUrl}/filters`);
  }

  /**
   * Clear all events for the current tenant.
   */
  clearBotEvents(): Observable<void> {
    return this.http.delete<void>(this.baseUrl);
  }
}